import {Sound} from '../../Sound'
import {CA} from '../../analytics/Analytics'
import {UILoadingRingController} from '../ui_loading_ring/UILoadingRingController'
import {TimeUtils} from '../../../../../shared/utils/TimeUtils'
import {uiManagerEvents} from '../../EntryShared'

export class UILobbyTableHeaderController {
    private readonly roomsTabDiv: HTMLDivElement
    private readonly spectateTabDiv: HTMLDivElement
    private readonly roomsIcon: HTMLDivElement
    private readonly spectateIcon: HTMLDivElement
    private readonly roomsTable: HTMLTableElement
    private readonly spectateTable: HTMLTableElement
    private readonly roomsTableBody: HTMLTableElement
    private readonly spectateTableBody: HTMLTableElement

    private readonly ACTIVE_TAB_CLASS = 'scene_lobby_mid_tabs_active'

    private readonly uiLoadingRingController: UILoadingRingController
    private readonly loadingRingTimeout

    private lastRefreshTimestamp: number
    private isTabInFocus: boolean = true

    private readonly refreshGameList: () => Promise<void>
    private readonly onTabChange: () => void

    constructor(refreshGameList: () => Promise<void>, onTabChange: () => void) {
        this.roomsTabDiv = document.getElementById('lobby_center_table_rooms_tab_div') as HTMLDivElement
        this.spectateTabDiv = document.getElementById('lobby_center_table_spectate_tab_div') as HTMLDivElement
        this.roomsIcon = document.getElementById('lobby_center_table_rooms_refresh_icon_rooms_table') as HTMLDivElement
        this.roomsIcon.style.display = 'none'
        this.spectateIcon = document.getElementById('lobby_center_table_rooms_refresh_icon_spectate_table') as HTMLDivElement
        this.roomsTable = document.getElementById('lobby_center_rooms_table') as HTMLTableElement
        this.spectateTable = document.getElementById('lobby_center_spectate_table') as HTMLTableElement
        this.roomsTableBody = document.getElementById('lobby_center_rooms_table_body') as HTMLTableElement
        this.spectateTableBody = document.getElementById('lobby_center_spectate_table_body') as HTMLTableElement
        this.uiLoadingRingController = new UILoadingRingController('lobby_center_')
        this.uiLoadingRingController.hideLoading()
        this.tableHeaderActions()
        this.updateLastRefreshTimestamp()
        this.initAutoRefresh()

        this.refreshGameList = refreshGameList
        this.onTabChange = onTabChange
    }

    showActiveTableBody() {
        clearTimeout(this.loadingRingTimeout)
        this.uiLoadingRingController.hideLoading()
        this.setRefreshIconsRotating(false)
        if(this.roomsTabDiv.classList.contains(this.ACTIVE_TAB_CLASS)) this.roomsTableBody.style.display = ''
        if(this.spectateTabDiv.classList.contains(this.ACTIVE_TAB_CLASS)) this.spectateTableBody.style.display = ''
    }

    updateLastRefreshTimestamp() {
        this.lastRefreshTimestamp = new Date().getTime()
    }

    isRoomListActive() {
        return this.roomsTable.style.display != 'none'
    }

    openSpectateTab() {
        this.clickedRefreshSpectate()
        this.onTabChange()
    }

    private setRefreshIconsRotating(rotating: boolean) {
        const rotationClass = 'rotate'
        if(rotating) {
            this.roomsIcon.classList.add(rotationClass)
            this.spectateIcon.classList.add(rotationClass)
        } else {
            this.roomsIcon.classList.remove(rotationClass)
            this.spectateIcon.classList.remove(rotationClass)
        }
    }

    private tableHeaderActions() {
        this.roomsTabDiv.onclick = () => {
            this.clickedRooms()

            this.onTabChange()
        }
        this.spectateTabDiv.onclick = () => {
            this.openSpectateTab()
        }
        this.spectateIcon.onclick = () => {
            this.clickedRefreshSpectate()
        }
    }

    private refreshIfLastRefreshTimestampPassed() {
        const currentTime = new Date().getTime()
        const timePassed = currentTime - this.lastRefreshTimestamp
        const refreshTimeSpectate = TimeUtils.MILLISECONDS * 30

        if((timePassed >= refreshTimeSpectate) && this.spectateTabDiv.classList.contains(this.ACTIVE_TAB_CLASS)) {
            this.refreshSpectate()
        }
    }

    private initAutoRefresh() {
        setInterval(() => {
            if(!uiManagerEvents.isSceneLobby()) return
            if(!this.isTabInFocus) return
            this.refreshIfLastRefreshTimestampPassed()
        }, TimeUtils.MILLISECONDS)

        // When the user switches away from the tab
        window.addEventListener('blur', () => {
            this.isTabInFocus = false
        })

        // When the user switches back to the tab
        window.addEventListener('focus', () => {
            this.isTabInFocus = true
            this.refreshIfLastRefreshTimestampPassed()
        })
    }

    clickedRefreshSpectate() {
        Sound.playSound(Sound.SoundType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.Lobby, CA.Label.ClickedLobbySpectateTab)
        this.refreshSpectate()
    }

    private clickedRooms() {
        Sound.playSound(Sound.SoundType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.Lobby, CA.Label.ClickedLobbyRoomsTab)
        CA.sendGoogleAnalyticsEvent(CA.Category.Lobby, CA.Label.ClickedLobbyRefresh)

        this.selectRooms()
    }

    private refreshSpectate() {
        this.roomsIcon.style.display = 'inline'
        this.setRefreshIconsRotating(true)

        this.roomsTabDiv.classList.remove(this.ACTIVE_TAB_CLASS)
        this.spectateTabDiv.classList.add(this.ACTIVE_TAB_CLASS)

        if(this.roomsTable.style.display != 'none') this.roomsTable.style.display = 'none'
        if(this.spectateTable.style.display != 'table') this.spectateTable.style.display = 'table'

        CA.sendGoogleAnalyticsEvent(CA.Category.Lobby, CA.Label.ClickedLobbyGames)
        void this.refreshGameList()
    }

    private selectRooms() {
        this.roomsIcon.style.display = 'none'
        this.roomsTabDiv.classList.add(this.ACTIVE_TAB_CLASS)
        this.spectateTabDiv.classList.remove(this.ACTIVE_TAB_CLASS)

        if(this.spectateTable.style.display != 'none') this.spectateTable.style.display = 'none'
        if(this.roomsTable.style.display != 'table') this.roomsTable.style.display = 'table'
    }
}
